export const WIDTH = 320;
export const HEIGHT = 180;

export const CENTER_X = 0.5*WIDTH;

export const CHARACTER_WIDTH = 40;
export const CHARACTER_HEIGHT = 60;

export const GROUND_POSITION = 140;
export const PLAYER_POSITION = 10;

export const START_WALK_SPEED = 150;
export const MAX_WALK_SPEED = 300;

export const FLYING_SPEED_ENVELOPE = 1.2;